export const tableCursorScrollStorageKey = (username: string): string =>
    `user-${username}.scrollByContentInTables`;
